import { createAction } from '@reduxjs/toolkit';


// eslint-disable-next-line import/prefer-default-export
export const setCurrentPlayingVideoId = createAction<any>(
  'SET_CURRENT_PLAYING_VIDEO_ID',
);

export const updateStartPlaybackFrom = createAction<any>(
  'UPDATE_START_PLAYBACK_FROM',
);
